import { SHIPMENT_SOLUTION_TYPES } from "~/cores/shipment.core";
import { createMockProduct, createProductsAndExchangeToProductsFn, createReturnReasonConfigBottom } from "../mockCore";

const productData1 = {
    product: createMockProduct({
        id: 1,
        productName: "Wrap Dress",
        imageSrc: "/mocks/Dress Green.jpeg",
        purchasePrice: 499,
        properties: [
            {
                type: "Color",
                value: "Green",
            },
            {
                type: "Size",
                value: "S",
            },
        ],
    }),
    exchangeToProductsData: {
        originalProductVariants: [
            {
                imageSrc: "/mocks/Dress Green.jpeg",
                properties: [
                    {
                        type: "Color",
                        value: "Green",
                        imageSrc: "/mocks/Dress Green.jpeg",
                    },
                    {
                        type: "Size",
                        value: "XS",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Dress Green.jpeg",
                inventoryTurnr: 0,
                inventoryMerchant: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Green",
                        imageSrc: "/mocks/Dress Green.jpeg",
                    },
                    {
                        type: "Size",
                        value: "L",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                imageSrc: "/mocks/Dress Black.jpeg",
                properties: [
                    {
                        type: "Color",
                        value: "Black",
                        imageSrc: "/mocks/Dress Black.jpeg",
                    },
                    {
                        type: "Size",
                        value: "S",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                imageSrc: "/mocks/Dress Blue.jpg",
                properties: [
                    {
                        type: "Color",
                        value: "Blue",
                        imageSrc: "/mocks/Dress Blue.jpg",
                    },
                    {
                        type: "Size",
                        value: "S",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                imageSrc: "/mocks/Dress Pink.jpg",
                properties: [
                    {
                        type: "Color",
                        value: "Pink",
                        imageSrc: "/mocks/Dress Pink.jpg",
                    },
                    {
                        type: "Size",
                        value: "S",
                    },
                ],
            },
        ],
    },
    similarProducts: [
        {
            actualProductId: 982,
            productName: "Lily Tee",
            imageSrc: "/mocks/T-shirt.jpeg",
            purchasePrice: 249,
            currency: "DEFAULT",
            properties: [
                {
                    type: "Size",
                },
            ],
            variants: [
                {
                    id: 4229,
                    productName: "Lily Tee",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                    productVariantTypeValues: ["XS"],
                },
                {
                    id: 4228,
                    productName: "Lily Tee",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                    productVariantTypeValues: ["M"],
                },
                {
                    id: 4227,
                    productName: "Lily Tee",
                    hasInventory: false,
                    properties: [
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                    productVariantTypeValues: ["L"],
                },
                {
                    id: 4226,
                    productName: "Lily Tee",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "XL",
                        },
                    ],
                    productVariantTypeValues: ["XL"],
                },
            ],
        },
    ],
};

const productData2 = {
    product: createMockProduct({
        id: 2,
        returnReasonConfig: createReturnReasonConfigBottom(),
        productName: "Highwaist Jeans",
        imageSrc: "/mocks/Jeans Black.jpeg",
        purchasePrice: 899,
        properties: [
            {
                type: "Size",
                value: "36",
            },
            {
                type: "Color",
                value: "Black",
            },
        ],
    }),
    exchangeToProductsData: {
        originalProductVariants: [
            {
                properties: [
                    {
                        type: "Color",
                        value: "Black",
                        imageSrc: "/mocks/Jeans Black.jpeg",
                    },
                    {
                        type: "Size",
                        value: "34",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Jeans Blue.jpeg",
                inventoryMerchant: 1,
                properties: [
                    {
                        type: "Color",
                        value: "Blue",
                        imageSrc: "/mocks/Jeans Blue.jpeg",
                    },
                    {
                        type: "Size",
                        value: "36",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Jeans Blue.jpeg",
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Blue",
                        imageSrc: "/mocks/Jeans Blue.jpeg",
                    },
                    {
                        type: "Size",
                        value: "34",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Jeans Blue.jpeg",
                properties: [
                    {
                        type: "Color",
                        value: "Blue",
                        imageSrc: "/mocks/Jeans Blue.jpeg",
                    },
                    {
                        type: "Size",
                        value: "38",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Jeans Blue.jpeg",
                inventoryMerchant: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Blue",
                        imageSrc: "/mocks/Jeans Blue.jpeg",
                    },
                    {
                        type: "Size",
                        value: "40",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Jeans Black.jpeg",
                properties: [
                    {
                        type: "Color",
                        value: "Black",
                        imageSrc: "/mocks/Jeans Black.jpeg",
                    },
                    {
                        type: "Size",
                        value: "38",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Jeans Black.jpeg",
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Black",
                        imageSrc: "/mocks/Jeans Black.jpeg",
                    },
                    {
                        type: "Size",
                        value: "40",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Jeans Brown.webp",
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Brown",
                        imageSrc: "/mocks/Jeans Brown.webp",
                    },
                    {
                        type: "Size",
                        value: "40",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Jeans Dirt.webp",
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Dirt Brown",
                        imageSrc: "/mocks/Jeans Dirt.webp",
                    },
                    {
                        type: "Size",
                        value: "40",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Jeans Forest Green.webp",
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Forest Green",
                        imageSrc: "/mocks/Jeans Forest Green.webp",
                    },
                    {
                        type: "Size",
                        value: "40",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Jeans Green.webp",
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Green",
                        imageSrc: "/mocks/Jeans Green.webp",
                    },
                    {
                        type: "Size",
                        value: "36",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Jeans Marine Blue.webp",
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Marine Blue",
                        imageSrc: "/mocks/Jeans Marine Blue.webp",
                    },
                    {
                        type: "Size",
                        value: "36",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Jeans Navy Blue.webp",
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Navy Blue",
                        imageSrc: "/mocks/Jeans Navy Blue.webp",
                    },
                    {
                        type: "Size",
                        value: "36",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Jeans Pink.webp",
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Pink",
                        imageSrc: "/mocks/Jeans Pink.webp",
                    },
                    {
                        type: "Size",
                        value: "36",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Jeans Purple.webp",
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Purple",
                        imageSrc: "/mocks/Jeans Purple.webp",
                    },
                    {
                        type: "Size",
                        value: "36",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Jeans Red.webp",
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Red",
                        imageSrc: "/mocks/Jeans Red.webp",
                    },
                    {
                        type: "Size",
                        value: "36",
                    },
                ],
            },

            // {
            //     inventoryTurnr: 0,
            //     properties: [
            //         {
            //             type: "Color",
            //             value: "Black",
            //         },
            //         {
            //             type: "Size",
            //             value: "43",
            //         },
            //     ],
            // },
            // {
            //     inventoryTurnr: 0,
            //     properties: [
            //         {
            //             type: "Color",
            //             value: "Black",
            //         },
            //         {
            //             type: "Size",
            //             value: "44",
            //         },
            //     ],
            // },
            // {
            //     inventoryTurnr: 0,
            //     properties: [
            //         {
            //             type: "Color",
            //             value: "Black",
            //         },
            //         {
            //             type: "Size",
            //             value: "45",
            //         },
            //     ],
            // },
            // {
            //     inventoryTurnr: 0,
            //     properties: [
            //         {
            //             type: "Color",
            //             value: "Black",
            //         },
            //         {
            //             type: "Size",
            //             value: "406",
            //         },
            //     ],
            // },
            // {
            //     inventoryTurnr: 0,
            //     properties: [
            //         {
            //             type: "Color",
            //             value: "Black",
            //         },
            //         {
            //             type: "Size",
            //             value: "407",
            //         },
            //     ],
            // },
            // {
            //     inventoryTurnr: 0,
            //     properties: [
            //         {
            //             type: "Color",
            //             value: "Black",
            //         },
            //         {
            //             type: "Size",
            //             value: "408",
            //         },
            //     ],
            // },
            // {
            //     inventoryTurnr: 0,
            //     properties: [
            //         {
            //             type: "Color",
            //             value: "Black",
            //         },
            //         {
            //             type: "Size",
            //             value: "409",
            //         },
            //     ],
            // },
            // {
            //     inventoryTurnr: 0,
            //     properties: [
            //         {
            //             type: "Color",
            //             value: "Black",
            //         },
            //         {
            //             type: "Size",
            //             value: "400",
            //         },
            //     ],
            // },
        ],
    },
};

const productData3 = {
    product: createMockProduct({
        id: 3,
        productName: "Lily Tee",
        imageSrc: "/mocks/T-shirt.jpeg",
        purchasePrice: 249,
        properties: [
            {
                type: "Color",
                value: "White",
            },
            {
                type: "Size",
                value: "S",
            },
        ],
    }),
    exchangeToProductsData: {
        originalProductVariants: [
            {
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Color",
                        value: "White",
                        hexColor: "#FFFFFF",
                    },
                    {
                        type: "Size",
                        value: "XS",
                    },
                ],
            },
            {
                properties: [
                    {
                        type: "Color",
                        value: "White",
                        hexColor: "#FFFFFF",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                inventoryMerchant: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Red",
                        hexColor: "#f03e3e",
                    },
                    {
                        type: "Size",
                        value: "L",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Purple",
                        hexColor: "#ae3ec9",
                    },
                    {
                        type: "Size",
                        value: "S",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Orange",
                        hexColor: "#ff922b",
                    },
                    {
                        type: "Size",
                        value: "L",
                    },
                ],
            },
            {
                properties: [
                    {
                        type: "Color",
                        value: "Black",
                        hexColor: "#000000",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
        ],
    },
};

const productData4 = {
    product: createMockProduct({
        id: 4,
        productName: "Teddy Vest",
        imageSrc: "/mocks/Vest.jpeg",
        purchasePrice: 799,
        properties: [
            {
                type: "Size",
                value: "S",
            },
            {
                type: "Color",
                value: "Beige",
            },
        ],
    }),
    exchangeToProductsData: {
        originalProductVariants: [
            {
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Size",
                        value: "XS",
                    },
                    {
                        type: "Color",
                        value: "Beige",
                        hexColor: "#ffd8a8",
                    },
                ],
            },
            {
                properties: [
                    {
                        type: "Size",
                        value: "M",
                    },
                    {
                        type: "Color",
                        value: "Blue",
                        hexColor: "#228be6",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Size",
                        value: "L",
                    },
                    {
                        type: "Color",
                        value: "Red",
                        hexColor: "#f03e3e",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Size",
                        value: "XL",
                    },
                    {
                        type: "Color",
                        value: "Green",
                        hexColor: "#37b24d",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                inventoryMerchant: 1,
                properties: [
                    {
                        type: "Size",
                        value: "XXS",
                    },
                    {
                        type: "Color",
                        value: "Yellow",
                        hexColor: "#ffd43b",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                inventoryMerchant: 1,
                properties: [
                    {
                        type: "Size",
                        value: "3XS",
                    },
                    {
                        type: "Color",
                        value: "Orange",
                        hexColor: "#f76707",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Size",
                        value: "4XL",
                    },
                    {
                        type: "Color",
                        value: "Black",
                        hexColor: "#212529",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Size",
                        value: "XXL",
                    },
                    {
                        type: "Color",
                        value: "White",
                        hexColor: "#f8f9fa",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Size",
                        value: "XL",
                    },
                    {
                        type: "Color",
                        value: "Pink",
                        hexColor: "#e64980",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Size",
                        value: "3XL",
                    },
                    {
                        type: "Color",
                        value: "Purple",
                        hexColor: "#ae3ec9",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Size",
                        value: "4XS",
                    },
                    {
                        type: "Color",
                        value: "Orange",
                        hexColor: "#ff922b",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Size",
                        value: "5XL",
                    },
                    {
                        type: "Color",
                        value: "Beige",
                        hexColor: "#ffd8a8",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Size",
                        value: "M",
                    },
                    {
                        type: "Color",
                        value: "Lime",
                        hexColor: "#94d82d",
                    },
                ],
            },
        ],
    },
};
//
// const productData5 = {
//     product: createMockProduct({
//         id: 5,
//         productName: "Teddy Vest",
//         imageSrc: "/mocks/Vest.jpeg",
//         purchasePrice: 799,
//         properties: [
//             {
//                 type: "Size",
//                 value: "S",
//             },
//             {
//                 type: "Color",
//                 value: "Beige",
//             },
//         ],
//     }),
//     exchangeToProductsData: {
//         otherProducts: [
//             createExchangeToProduct({
//                 product: createMockProduct({
//                     id: "olle",
//                     productName: "something",
//                     imageSrc: "/mocks/T-shirt.jpeg",
//                     properties: [
//                         {
//                             type: "Size",
//                             value: "S",
//                         },
//                         {
//                             type: "Color",
//                             value: "Beige",
//                         },
//                     ],
//                 }),
//                 variants: [
//                     {
//                         properties: [
//                             {
//                                 type: "Size",
//                                 value: "XS",
//                             },
//                         ],
//                     },
//                 ],
//             }),
//         ],
//     },
// };

const productsAndExchangeToProductsFn = createProductsAndExchangeToProductsFn([
    productData1,
    productData2,
    productData3,
    productData4,
    // productData5
]);

export function getExchangeToProducts({ productId }) {
    return productsAndExchangeToProductsFn.exchangeToProductsFn({ productId });
}

export function getProducts() {
    return {
        sessionId: "170bfc7b-8910-43a7-8903-52c9894ed015",
        pickupDateSelectionAllowed: true,
        shipmentSolutions: [
            {
                carrier: "DOORIS",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 0,
            },
            {
                carrier: "BUDBEE",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 39,
            },
            {
                carrier: "POSTNORD",
                type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL.key,
                cost: 39,
            },
            {
                type: SHIPMENT_SOLUTION_TYPES.RETURN_IN_STORE.key,
                cost: 0,
            },
            // {
            //     // carrier: SHIPMENT_CARRIERS.BUDBEE,
            //     type: SHIPMENT_SOLUTION_TYPES.MANUAL.key,
            //     cost: 39,
            // },
            // {
            //     // carrier: SHIPMENT_CARRIERS.BUDBEE,
            //     type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL_MANUAL_UPLOAD.key,
            //     cost: 39,
            // },
        ],
        paidShipping: 40,
        turnrShippingCost: 59,
        currencyCode: "SEK",
        orderCreatedAt: "2024-06-12T14:29:13.218779489Z",
        remainingReturnDays: 28,
        remainingWithdrawalDays: 14,
        refundOptions: [
            {
                type: "BASIC",
            },
            {
                type: "GIFT_CARD",
                bonusPercentage: 0.2,
            },
        ],
        products: productsAndExchangeToProductsFn.products,
    };
}

export function getSimilarProducts({ productId }) {
    return productsAndExchangeToProductsFn.similarProductsFn({ productId });
}
